export default {
    // PATHにURLが含まれているか前方一致でチェックしてクエリーパラメータを返す
    url_check: function (url, path) {
        var queries = {};
        if(url.startsWith(path)){
            var queryStr = location.search.slice(1); // クエリ文字列を取得(文頭?を除外)
            queryStr.split('&').forEach(function(queryStr) {
                // = で分割してkey,valueをオブジェクトに格納
                var queryArr = queryStr.split('=');
                queries[queryArr[0]] = queryArr[1];
            });
        }
        return queries;
    },
}